// 登录控制
const state = {
  token: window.localStorage.getItem('Authorization'),
  roleName: window.localStorage.getItem('roleName'),
  mobileHistory: (window.localStorage.getItem('mobile') || '').split(',').filter(mobile => { return mobile }),
  user: {
    doEntry: false,
    entry: 'login',
    params: {}
  },
  showInquiry:false,
  shop: {
    id: null
  }
}

const mutations = {
  saveUserInfo(state, data) {
    state.token = data.token
    state.roleName = data.roleName
    window.localStorage.setItem('Authorization', state.token)
    window.localStorage.setItem('roleName', state.roleName)
    state.user = Object.assign({}, state.user, data.user)
  },
  saveMobile(state, newMobile) {
    let mobiles = (window.localStorage.getItem('mobile') || '').split(',').filter(mobile => {
      return mobile && mobile != newMobile
    })
    mobiles.unshift(newMobile)
    state.mobileHistory = mobiles
    window.localStorage.setItem('mobile', state.mobileHistory.join(','))
  },
  removeMobile(state, oldMobile) {
    let mobiles = (window.localStorage.getItem('mobile') || '').split(',').filter(mobile => {
      return mobile && mobile != oldMobile
    })
    state.mobileHistory = mobiles
    window.localStorage.setItem('mobile', state.mobileHistory.join(','))
  },
  userEnter(state, params) {
    state.user.entry = params.action
    delete params.action
    state.user.params = params
    state.user.doEntry = true
  },
  closeEnter(state) {
    state.user.doEntry = false
  },
  shopInfo(state, data) {
    state.shop = data
  },
  clearShopInfo(state) {
    state.shop = {}
  }
}

const actions = {
  async login(context, logData) {
    // 快速注册
    let user = logData.user || logData
    if (!logData.user) {
      let { data } = await global.$ComAxios.post(logData.ic ? global.$ComDomain.User.loginByIc : global.$ComDomain.User.login, user)
      if (data.status == 200) {
        logData = data
      } else {
        return Promise.reject()
      }
    }

    // 备份旧userId
    let userId = context.state.user.userId
    context.commit('saveUserInfo', logData)
    // 仅登录保存
    context.commit('saveMobile', user.mobile)
    await global.$ComAxios.put(global.$ComDomain.Model.revise + userId)
    // 关闭登录框
    context.state.user.doEntry = false

    // 取店铺信息
//    context.dispatch('shopInfo')
  },
  logout(context) {
    // 注销
    context.state.token = ''
    window.localStorage.setItem('Authorization', '')
    // 清空店铺信息
    context.commit('clearShopInfo')
  },
  async userInfo(context) {
    let { data } = await global.$ComAxios.get(global.$ComDomain.User.info)
    if (data.status == 200) {
      // 保存用户信息
      context.commit('saveUserInfo', data)

      // 取得其他用户信息
      if (!context.getters.isLogined) {
        // 清空店铺信息
        context.commit('clearShopInfo')
        return Promise.resolve(data)
      } else {
        // 取店铺信息
    //    await context.dispatch('shopInfo')
        return Promise.resolve(data)
      }
    } else {
      return Promise.reject()
    }
  },
  shopInfo(context) {
    return new Promise((resolve, reject) => {
      global.$ComAxios.post('market:/shop/check').then(response => {
        if (response.status == 200 && response.data.status == 200) {
          // 取店铺id
          context.commit('shopInfo', { id: response.data.result.shopId })
          resolve(response.data.result.shopId)
        } else {
          return Promise.reject(response.data.msg)
        }
      }).catch(error => {
        console.log(error)
        reject()
      })
    })
  }
}

const getters = {
  isLogined(state) {
    return !!state.token && !/^anonymous.+$/.test(state.token)
  },
  hasShop(state) {
    return state.shop.id != null
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/commons/store/Controlor.js